import { authClient } from "@/lib/auth-client";
import { useRouteLoaderData } from "react-router";

export function useAuthLoaderData(){
    return useRouteLoaderData<typeof authClient.$Infer.Session>("root")
}